<template>
  <div class="row minWidth100">
    <div class="col-12 padd-0">
      <b-list-group class="minWidth100">
        <b-list-group-item
          class="chat-item"
          v-for="(msg, index) in msgs"
          :key="msg.key"
          v-chat-scroll
        >
          <div
            v-if="!isMain && prevMsgSendDate && prevMsgSendDate.includes(index)"
            class="dateMessageClass"
            :id="'hDate'+index"
          >
            <div class="row">
              <div class="col-5">
                <hr />
              </div>
              <div class="col-2" style="line-height: 33px">
                {{msg.sendDate.toString().split(' ')[0]}}
                {{msg.sendDate.toString().split(' ')[1]}}
                {{msg.sendDate.toString().split(' ')[2]}}
              </div>
              <div class="col-5">
                <hr />
              </div>
            </div>
          </div>

          <!-- Reminders Section -->
          <div
            class="row"
            v-if="valid(msg.reminders) && msg.reminders.length > 0"
            style="margin-top: 10px; margin-bottom: 20px;"
          >
            <div class="col vcntr">
              <hr class="style-one_chat_before" />
            </div>
            <div class="col padd-0 syscont-mw">
              <div class="row" v-for="(reminder, ind) in msg.reminders" :key="'sysmsg-' + ind">
                <div class="col-12 padd-0 cntr">
                  <div class="row">
                    <div class="col-12 padd-0 sys-msg-header">
                      {{Sh(reminder.category)}} {{Sh(reminder.type)}} "{{reminder.title}}" was sent to {{reminder.phone}} on {{new Date(reminder.sent_time).toLocaleString("en-US", {
                      timeZone: "America/Edmonton"
                      })}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 padd-0 sys-msg">{{reminder.sent_msg}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col vcntr">
              <hr class="style-one_chat_after" />
            </div>
          </div>

          <!-- Reminders Section END -->

          <div
            v-if="msg.author_type === 'admin' || msg.author_type === 'manager' || msg.author_type === 'bot'"
          >
            <!-- <div v-if="msg.route.from == 'admin'"> -->
            <div
              class="row"
              :id="isMain ? 'msg-' + index : prevMsgSendDate.includes(index) ? 'mshDate'+index : 'hDate'+index"
            >
              <div class="col-5"></div>
              <div class="col-6" style="text-align: end; padding-right: 0;">
                <div class="employerMessage">{{msg.data.text}}</div>
              </div>
              <div class="col-1 messagesAvatar">
                <b-avatar :size="35" class="avatarka" :src="userPhotoURL"></b-avatar>
              </div>
              <div class="col-5"></div>
              <div class="col-3 sendDateEmployer"></div>
              <div
                class="col-3 sendDateClient"
              >{{msg.author}} ({{msg.sendDate.toString().split("GMT")[0].split(' ')[4]}})</div>

              <div class="col-1"></div>
            </div>

            <div
              class="row"
              v-if="msg.data.suggestions != undefined && msg.data.suggestions.length > 0"
            >
              <div class="col-1"></div>
              <div class="col-11">
                <div
                  class="row"
                  v-for="(rwSuggs, rwIndex) in suggestionsShowRows(msg.data.suggestions)"
                  :key="rwIndex"
                >
                  <div class="col-3 ofsuggstyle">{{rwIndex == 0 ? 'Offered suggestions:' : ''}}</div>
                  <div class="col-2 suggShow" v-for="sug in rwSuggs" :key="sug">{{sug}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-if="!(valid(msg.service) && msg.service.hiddenMessage == 'welcome')"
              class="row"
              :id="isMain ? 'msg-' + index : prevMsgSendDate.includes(index) ? 'mshDate'+index : 'hDate'+index"
            >
              <div class="col-1 messagesAvatar">
                <b-avatar :size="35" class="avatarka" :src="clientPhotoURL"></b-avatar>
              </div>
              <div class="col-6" style="padding-left:0;">
                <div class="clientMessage">{{msg.data.text}}</div>
              </div>
              <div class="col-5"></div>
              <div class="col-1"></div>
              <!-- <div class="col-3 sendDateEmployer">{{displayUserNames}}</div> -->
              <div
                class="col-3 sendDateEmployer"
              >customer ({{msg.sendDate.toString().split("GMT")[0].split(' ')[4]}})</div>
              <div class="col-3 sendDateClient"></div>

              <div class="col-5"></div>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatWindow",

  props: {
    msgs: Array,
    prevMsgSendDate: Array,
    isMain: Boolean
  },
  data() {
    return {
      clientPhotoURL:
        "https://img2.freepng.ru/20180625/at/kisspng-business-game-avatar-computer-program-google-smart-object-5b315c2b2ad958.6413531715299615151755.jpg",
      userPhotoURL:
        "https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Favatar_pict.png?alt=media&token=67728320-df0d-4f9c-a63b-a7340b4fd3fb"
    };
  },

  mounted() {},

  methods: {
    suggestionsShowRows(arr) {
      let len = 4;
      var chunks = [],
        i = 0,
        n = arr.length;
      while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
      }

      return chunks;
    },

    detectScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      console.log("SCROOLLL :", this.isMain, scrollTop);
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$emit("scrollToBtm", false);
      } else if (scrollTop == 0) {
        this.$emit("scrollToBtm", true);
      }
    },
    valid(val) {
      return val != undefined && val != null && val !== "";
    },
    Sh(v) {
      return `${v.substring(0, 1).toUpperCase()}${v.substring(1)}`;
    }
  }
};
</script>
<style>
.padd-0 {
  padding: 0;
}
.vcntr {
  align-self: center;
}
.cntr {
  text-align: center;
}
.syscont-mw {
  min-width: 55%;
}
.sys-msg-header {
  color: rgba(38, 109, 179, 0.78);
  font-weight: bold;
  font-style: italic;
}
.sys-msg {
  color: #778899eb;
  font-style: italic;
}
hr.style-one_chat_before {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgb(38, 109, 179, 0.4),
    rgb(38, 109, 179)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}
hr.style-one_chat_after {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgb(38, 109, 179),
    rgb(38, 109, 179, 0.4),
    rgba(0, 0, 0, 0)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}

.suggShow {
  margin: 5px;
  text-align: center;
  border: 1px solid #77889959;
  border-radius: 0.3rem;
  padding: 3px;
  color: #778899eb;
}
.ofsuggstyle {
  color: #778899eb;
  padding: 3px;
  margin: 5px;
  text-align: right;
  align-self: center;
}
.messagesAvatar {
  padding: 0px;
  text-align: center;
}
.sendDateClient {
  text-align: right;
  font-size: 12px;
}
.sendDateEmployer {
  text-align: left;
  font-size: 12px;
  /* margin-bottom: 20px; */
}
.clientMessage {
  color: #32465a;
  background-color: rgb(229, 230, 233);
  border-radius: 20px;
  padding: 10px 17px;
  font-size: 16px;
  word-break: break-word;
  width: fit-content;
  float: left;
}

.employerMessage {
  color: #ffffff;
  background-color: #266db3;
  /* background-color: rgb(66, 135, 245); */
  border-radius: 20px;
  padding: 10px 17px;
  font-size: 16px;
  word-break: break-word;
  width: fit-content;
  float: right;
}
.minWidth100 {
  min-width: 100%;
}
.chat-item {
  background-color: #ffffff;
  border: none;
}

.avatarka {
  background-color: rgba(255, 255, 255, 0);
}
</style>




